import typeOf from '../../helpers/typeOf';

// Static constants for conversion parameter handling
const metaUtmParams = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];
const metaParamsCount = 4;

export const getQuery = (query = {}, extra = false) => {
    let params = {};
    const fn = key => {
        key = typeOf.isNumeric(key) ? `param${key + 1}` : key;

        params[key] = query[key] || '';
        query[key] && delete query[key];
    };

    (Array.isArray(metaUtmParams) ? metaUtmParams : []).map(fn);
    Array.from(Array(Number.isFinite(metaParamsCount) ? metaParamsCount : 0).keys()).map(fn);

    if (extra) {
        for (let key in query) {
            params[key] = query[key];
        }
    }

    return params;
};
